/**
 * 運搬ルート
 * ドロップダウン展開用
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/transport_routes`

const search_transport_route = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {

    /**
     * 運搬ルート詳細一覧
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 運搬ルート詳細一覧(絞り込み条件付き)
     * @param commit
     * @param {boolean} without_invisible 非表示を含めない場合はtrue
     * @param {boolean} first_trader_owned 区間1の収運が自社で絞り込む場合はtrue
     * @param {boolean} self_emission 排出自己運搬で絞り込む
     * @param {boolean} self_emission_include_own 排出自己運搬を自社の運搬先で絞り込む
     * @param {boolean} without_self_emission 排出自己運搬を除く
     * @param {boolean} proxy_request 他社運搬で絞り込む
     * @param {boolean} general 一般廃棄物で絞り込む
     * @param {boolean} without_non_reporting 処分業者が報告不要ルートを除く
     * @param {number} item_id アイテムID
     * @param {string} item_type アイテムタイプ
     * @param {string} sales_item_price_code 売上品目コード
     * @param {boolean} without_none_subscribe 未加入を除く
     * @return {Promise<unknown>}
     */
    search ({commit }, { without_invisible, first_trader_owned, self_emission, self_emission_include_own, without_self_emission, proxy_request, general, without_non_reporting, item_id, item_type, sales_item_price_code, without_none_subscribe }) {
      const params = {
        without_invisible: without_invisible,
        first_trader_owned: first_trader_owned,
        self_emission: self_emission,
        self_emission_include_own: self_emission_include_own,
        without_self_emission: without_self_emission,
        proxy_request: proxy_request,
        general: general,
        without_non_reporting: without_non_reporting,
        item_id: item_id,
        item_type: item_type,
        sales_item_price_code: sales_item_price_code,
        without_none_subscribe: without_none_subscribe,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })

    },
    /**
     * 運搬ルート詳細の取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_transport_route
